import { useRef, useState, useEffect } from "react";
import {
  languageChange,
  currentSelectedLanguage,
} from "../../../StateManagement/actions";
import { useSelector, useDispatch } from "react-redux";

import "./OpenNotes.css";
export default function OpenNotes({
  openNotesClose,
  onClickContinue,
  continueText,
  rdocsLevel
}) {
  const notifyReader = useRef();
  const senderNotesRef = useRef();
  const handlerOpenNotesClosed = () => {
    openNotesClose();
  };

  const handleToContinue = (senderNotes, notifyToReader) => {
    onClickContinue(senderNotes, notifyToReader);
  };
  const selectedLanguage = useSelector(currentSelectedLanguage);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(languageChange(localStorage.getItem("language")));
  }, []);
  return (
    <div
      className="modal"
      id="myModal1"
      style={{ display: "block", backgroundColor: "#8080801c" }}>
      <div className="modal-dialog modal-dialog-centered modal-customelg">
        <div className="modal-content">
          <div className="modal-header pb-1">
            <h4
              className="d-flex align-items-center text-danger fw-bold "
              htmlFor="">
              {selectedLanguage.LstLanguageCodes.UI_Note}
            </h4>
            <button
              type="button"
              className="btn btn-outline-danger modalclose download"
              onClick={(e) => handlerOpenNotesClosed()}>
              <span className="material-icons font-20">highlight_off</span>
            </button>
          </div>
          <div className="modal-body  justify-content-between d-flex flex-wrap">
            <textarea
              className="textareaPadding w-100 custom-inputBorder"
              draggable="false"
              name="ReaderNotes"
              placeholder= {selectedLanguage.LstLanguageCodes.UI_Optional}
              rows="5"
              cols="58"
              maxLength="255"
              ref={senderNotesRef}
            //onChange={(e) => setSenderNotes(e.target.value)}
            ></textarea>
            {rdocsLevel !== "Track Views" &&
              <div className="mt-2">
                <label className="label">
                  <input type="checkbox" className="notifyChk" ref={notifyReader} />
                  {selectedLanguage.LstLanguageCodes.UI_NotifyReader}
                </label>
              </div>
            }
          </div>

          <div className="mb-2 justify-content-center d-flex">
            <button
              type="button"
              className="btn btn-secondary py-2 approve"
              data-bs-dismiss="modal"
              onClick={() =>
                handleToContinue(
                  senderNotesRef.current.value,
                  (notifyReader.current !== null && notifyReader.current !== undefined && notifyReader.current !== "") ? notifyReader.current.checked : false
                )
              }>
              {continueText}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
